import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/leftArrowFilled.svg'
import _imports_1 from '@/assets/rightArrowFilled.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2df21c7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "responsive-pagination hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" }
const _hoisted_2 = { class: "text-sm text-gray-700" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_5 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-3 h-4"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "mx-2 flex" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex items-center justify-center w-10 h-8 ml-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pr-2" }, "of", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-3 h-4"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.display==true)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex items-center justify-between bottom-0 px-5 py-3", (_ctx.currentPage * _ctx.pageSize) > (_ctx.dynamicPagination) && (_ctx.entityId==20010||_ctx.entityId==20011) ?'border-t border-lightgrey':'border-none'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode(" Showing "),
              _createElementVNode("span", _hoisted_3, _toDisplayString((_ctx.currentPage - 1) * _ctx.pageSize + 1), 1),
              _createTextVNode(" - "),
              (_ctx.dynamicPagination > _ctx.pageSize)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.currentPage * _ctx.pageSize), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.dynamicPagination), 1)),
              _createTextVNode(" of "),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.dynamicPagination), 1),
              _createTextVNode(" results ")
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["inline-flex items-center justify-center border border-lightgrey rounded w-8 h-8 cursor-pointer", _ctx.cantGoBack ? 'disabled pointer-events-none' : '']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPreviousPage()))
            }, _hoisted_9, 2),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
                class: "inputboxstyling dropDownWidth"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: i
                  }, _toDisplayString(i), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.currentPage]
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(_ctx.totalPages), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["inline-flex items-center justify-center border border-lightgrey rounded w-8 h-8 cursor-pointer", _ctx.cantGoForward ? 'disabled pointer-events-none':'']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToNextPage()))
            }, _hoisted_15, 2)
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}